import urls from "../constants";
import { useFetch } from "./useFetch";

export function usePrayerRequests() {
    const { sendGet, sendPost } = useFetch();

    const getPrayerRequests = async (token) => {
        try {
            const response = await sendGet(urls.GET_PRAYER_REQUESTS, {
                AccessToken: token
            });
            return response.map(item => ({
                ...item,
                createdDate: new Date(item.createdDate)
            }));
        } 
        catch (error) {
            console.error(error);
            return [];
        }
    }

    const updatePrayerRequestStatus = async (token, prayerRequestID, status) => {
        try {
            const updatedPrayerRequest = await sendPost(urls.UPDATE_PRAYER_REQUEST_STATUS, {
                    AccessToken: token
                },
                JSON.stringify({prayerRequestID, status})
            );
            return {...updatedPrayerRequest, createdDate: new Date(updatedPrayerRequest.createdDate)};
        } 
        catch (error) {
            console.error(error);
            throw error;
        }
    }

    return { getPrayerRequests, updatePrayerRequestStatus };
}